module.exports = __webpack_public_path__ + "static/media/info.d41d8cd9.md";